import publicApi from "@/services/publicApi";
import { PartnerDetailsType } from "@/types/partner/Partner";

class CompleteRegistrate {
  execute = async (partnerId: string, partner: PartnerDetailsType) => {
    const categoryId = Number(partner.categoryId);
    const res = await publicApi().post(`registrate/continue/${partnerId}`, {
      name: partner.name,
      tax: partner.tax,
      phone: partner.phone.replace(/\D/g, ""),
      nickName: partner.nickName,
      email: partner.email,
      document: partner.document.replace(/\D/g, ""),
      pixkey: partner.pixkey,
      typeCompany: partner.typeCompany,
      cnaeCode: "1",
      categoryId,
      useAssociateTax: partner.useAssociateTax !== false,
      address: {
        street: partner.address.street,
        state: partner.address.state,
        addressNumber: partner.address.addressNumber,
        neighborhood: partner.address.neighborhood,
        complement: partner.address.complement,
        zipCode: partner.address.zipCode.replace(/\D/g, ""),
        cityName: partner.address.cityName,
        ibge: partner.address.ibge,
      },
      user: {
        name: partner.user.name,
        motherName: partner.user.motherName,
        nickname: partner.user.email,
        birthdate: partner.user.birthdate,
        email: partner.user.email,
        phone: partner.user.phone.replace(/\D/g, ""),
        document: partner.user.document.replace(/\D/g, ""),
        password: partner.user.password,
      },
      associates: partner.associates,
      businessHours: partner.businessHours,
      digitalAccountNumber: partner.digitalAccountNumber,
      digitalAccountDocument: partner.document.replace(/\D/g, ""),
      contractFile: partner.contractFile || "PF",
      registrationStatusFile: partner.registrationStatusFile || "PF",
    });
    return res.data;
  };
}

export { CompleteRegistrate };
